import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactSignatureCanvas, { SignatureCanvas } from "react-signature-canvas";
import { FormikValues } from "formik";
import DisabledByDefaultRoundedIcon from "@mui/icons-material/DisabledByDefaultRounded";

import { BoxWithLabel, Input } from "components";
import { useCanvasWidth } from "hooks";

import { ClearSignButton, HiddenBlock, Wrapper } from "./Signature.css";

interface Props {
  name: string;
  formik: FormikValues;
}

export const Signature = ({ name, formik }: Props) => {
  const { t } = useTranslation();
  const parentRef = useRef<HTMLDivElement | null>(null);
  const [sign, setSign] = useState<ReactSignatureCanvas | null>(null);

  const canvasWidth = useCanvasWidth(parentRef);
  const formikValue = formik.values?.[name];

  const handlerClear = () => {
    sign?.clear();
    formik.setFieldValue(name, "");
  };

  const handlerSaveSignCanvas = () => {
    const signatureData = sign?.toData();
    if (signatureData) {
      formik.setFieldValue(name, JSON.stringify(signatureData));
    }
  };

  return (
    <Wrapper>
      <HiddenBlock>
        <Input label="" name={name} type="hidden" formik={formik} />
      </HiddenBlock>

      <BoxWithLabel
        label={t("signature")}
        error={formik.touched[name] && t(formik.errors[name])}
      >
        <div ref={parentRef}>
          <SignatureCanvas
            onEnd={handlerSaveSignCanvas}
            canvasProps={{ width: canvasWidth, height: 75 }}
            ref={(data) => setSign(data)}
          />
        </div>
      </BoxWithLabel>

      {formikValue && (
        <ClearSignButton onClick={handlerClear}>
          <DisabledByDefaultRoundedIcon />
        </ClearSignButton>
      )}
    </Wrapper>
  );
};
